import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { createGroup } from 'Services';
import { setGroup } from 'Store';
import { RQ_CREATE_GROUPS } from 'Utils';

type Options = {
    mutationOptions?: any;
};

const addGroups = () => (groups: Group[]) => {
    return createGroup(groups);
};

export default function useAddGroups({ mutationOptions: { onSuccess, onError } = {} }: Options) {
    const dispatch = useDispatch();
    const ret = useMutation([RQ_CREATE_GROUPS], addGroups(), {
        onSuccess: (data, variables, context) => {
            if (onSuccess) {
                onSuccess(data, variables, context);
                dispatch(setGroup(variables[0]?.name));
            }
        },
        onError: async (error: any, variable, context) => {
            onError?.(error, variable, context);
        }
    });

    return ret;
}
